import { createFileRoute } from '@tanstack/react-router';
import { LlmPage } from '@/features/settings/LlmPage';

export const Route = createFileRoute('/app/settings/ai')({
  component: LlmPage,
  staticData: { title: 'AI drafting · Settings' },
});
